import { render } from "./NewsDetail.vue?vue&type=template&id=6cd65a8e&scoped=true"
import script from "./NewsDetail.vue?vue&type=script&lang=js"
export * from "./NewsDetail.vue?vue&type=script&lang=js"

import "./NewsDetail.vue?vue&type=style&index=0&id=6cd65a8e&scoped=true&lang=css"

import exportComponent from "D:\\pro\\node-workspace\\machitabi_Vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd65a8e"]])

export default __exports__